import { Icon } from '@graftcode/design-system'

export const DEFAULT_SEARCH_PLACEHOLDER = 'Start typing to search for items or perform an action'

export const SEARCH_MODAL_MIN_QUERY_LENGTH = 1

export const SEARCH_MODAL_ITEM_KIND = {
  Documentation: 'documentation',
  Glossary: 'glossary',
  QuickStart: 'quick-start',
  Service: 'service',
  Graft: 'graft',
  Module: 'module',
  Gateway: 'gateway',
  Action: 'action',
} as const

export const SEARCH_MODAL_ICON_MAP = {
  [SEARCH_MODAL_ITEM_KIND.QuickStart]: Icon.FastForwardRegular,
  [SEARCH_MODAL_ITEM_KIND.Glossary]: Icon.BookRegular,
  [SEARCH_MODAL_ITEM_KIND.Documentation]: Icon.DocumentRegular,
  [SEARCH_MODAL_ITEM_KIND.Service]: Icon.DSService,
  [SEARCH_MODAL_ITEM_KIND.Graft]: Icon.BoxRegular,
  [SEARCH_MODAL_ITEM_KIND.Module]: Icon.BoxRegular,
  [SEARCH_MODAL_ITEM_KIND.Gateway]: Icon.DSCodeGatewayFilled,
  [SEARCH_MODAL_ITEM_KIND.Action]: Icon.ArrowRoutingRegular,
}
